import { lazy } from "react";

export { POSTS_MODERATION_PATH } from "./path";
export const PostsModerationPage = lazy(() => import("./page"));
